import React, {
	Component
} from 'react';
import styled from 'styled-components';
import { Button } from './UI';
import { store } from '../stores/mainStore';
import { ButtonBar } from './UI';

const config = window.dodConfig;

const useBolt = process.env.INTEGRATION === 'greentube';

const HeartPage = styled.div`
	box-sizing: border-box;
	width: 100%;
	height: 100%;
	background: rgba(0,0,0, 0.75);
	display: flex;
	justify-content: center;
	align-items: center;
	color: white;
	font-size: 32px;
	pointer-events: auto;
`

const Content = styled.div`
	display: flex;
	width: 100%;
	height: 100%;
	padding-top: ${p => config.isLandscape ? 4 : 25}%;
	box-sizing: border-box;
	background-size: 100% auto;
	text-align: center;
	flex-direction: column;
`

const CloseBox = styled.div`
	position: relative;
	display: inline-block;
	width: ${p => config.isLandscape ? 40 : 90}%;
	margin: 0 auto;
`

const BoxContent = styled.img`
	width: 100%;
`

const CloseButton = styled.img`
	width: 12%;
	position: absolute;
	top: -4%;
	right: -4%;
`
export class ModalHeart extends Component {

	continue(){
		store.modal = '';
	}

	learn(){
		window.manager.playAudio("poopPop");
		store.modal = 'learn';
	}

	render() {
		var boxImg = useBolt ? 'bolt' : 'heart';
		return (
			<HeartPage>
				<Content>
					<CloseBox>
						<CloseButton src="/assets/btn_close.png" onClick={e => store.modal = ''}/>
						<BoxContent  src={`/assets/${boxImg}_box.jpg`}/>
					</CloseBox>
					<ButtonBar style={{paddingTop: '1%'}}>
						<Button learnmore onClick={this.learn}/>
					</ButtonBar>
				</Content>
			</HeartPage>
		)
	}
}